import {AfterViewInit, Component, Inject, OnInit, ViewChild, ElementRef, HostListener} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {DOCUMENT} from '@angular/platform-browser';
import {
  AccountService,
  RecipeService,
  TarifService,
  UserRequest,
  LandingService,
  DatepickerService,
  IntroService,
  RestService,
  HtmlHelper,
  CookieService,
  PlanningService,
  Configuration, AppConfig, ChangeFiltersService
} from '../shared/shared.module';
import * as introJs from 'intro.js/intro';
// tslint:disable-next-line:import-blacklist
import {Observable} from 'rxjs';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss']
})

export class HeaderMobileComponent implements OnInit, AfterViewInit {
  public Config: Configuration;
  burgerToggleStatus = false;
  searchToggleStatus = false;
  filtersToggleStatus = false;
  fakeOpen = false;
  datepickerToggleStatus = false;
  changeWeeksBarStatus = false;
  searchBoxStatus = false;
  menuDocumentsListStatus = false;
  menuInstructionListStatus = false;
  menuLKListStatus = false;
  menLPlanningStatus = false;
  public currentTab: string;
  tariffClasses: object = {
    1: 'basic',
    2: 'premium',
    3: 'premium',
    4: 'premium'
  };
  newMessage: boolean;
  currentTariffId: number;
  redirectToWelcome: boolean;

  isLogged: boolean;
  isLandingsHeader: boolean;
  isSortActive: boolean;
  user = new UserRequest();
  authorizationPopupDisplayed = false;
  restorationPopupDisplayed = false;
  booksFiltersAmount = 0;
  allActiveFiltersAmount = 0;
  categoryFiltersAmount = 0;
  groupFilterCheckAmount = 0;
  ingredientFilterAmount = 0;
  categoryFilterEvent;
  showHeaderFilters: boolean;
  intro = introJs();
  completeIntro = false;
  stateReadyMenu = [];
  allowResetMenu: boolean;
  @ViewChild('categoryFilter') categoryFilter;
  @ViewChild('groupFilter') groupFilter;
  @ViewChild('ingredientFilter') ingredientFilter;
  @ViewChild('bookFilter') bookFilter;
  @ViewChild('datepicker') datepicker;
  @ViewChild('filterMobile') filterMobile: ElementRef;
  introStage1 = [];
  introStage2 = [];
  introStage3 = [];
  introStage4 = [];
  isMobile: boolean;
  windowWidth: number = window.innerWidth;
  popupStartIntro = false;
  showTimeCookieStudyPopup = true;
  stageIntro = 0;
  readyMenusArr = [];
  menuReadyMenuOpenStatus = false;
  readyMenuTimeout = null;
  isRunGetRecipe = true;

  constructor(
      private planningService: PlanningService,
      private accountService: AccountService,
      private router: Router,
      private recipeService: RecipeService,
      private tarifService: TarifService,
      private landingService: LandingService,
      private datepickerService: DatepickerService,
      public introService: IntroService,
      public restService: RestService,
      private cookieService: CookieService,
      public changeFiltersService: ChangeFiltersService,
      @Inject(DOCUMENT) private document: Document
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
  }

  ngOnInit() {
    this.Config = AppConfig.config;
    this.introStage1 = [
      {
        element: '#intro1',
        intro: this.Config.introTexts[0]
      }, {
        element: '#intro2',
        intro: this.Config.introTexts[1]
      }, {
        element: '#intro3',
        intro: this.Config.introTexts[2]
      }, {
        element: '#intro4',
        intro: this.Config.introTexts[3]
      }
    ];
    this.introStage2 = [
      {
        element: '#intro6',
        intro: this.Config.introTexts[4]
      }
    ];
    this.introStage3 = [
      {
        element: '#intro7',
        intro: this.Config.introTexts[5]
      }
    ];
    this.introStage4 = [
      {
        element: '#intro17',
        intro: this.Config.introTexts[15]
      }
    ];
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
    this.getLocation(window.location.pathname).then(x => {
      this.getAccountService();
    });
    this.router.events.subscribe((route: NavigationEnd) => {
      this.getLocation(route.url).then(x => this.getAccountService());
    });

    this.accountService.getCredentialsPromise().then(cred => {

      if (cred.Id_Session) {
        this.accountService.getNewMessageInfo().subscribe(resp => this.newMessage = resp);
      }
      this.tarifService.get().then(resp => {
        const tariffs = resp;
        tariffs.map(tar => {
          const tarif = tar.Subtarif.find(x => x.Id_Tarif === cred.Id_Tarif);
          if (tarif) {
            this.currentTariffId = tarif.Id_Tarif;
          }
        });
      });
    });

    this.datepickerService.getWeek();

    this.accountService.showStudyPopupSub().subscribe( flag => {
      if (flag) {
        this.setListenerForStudyCookie();
      }
    });

    this.introService.getPopupStartIntro().subscribe(stage => {
      this.popupStartIntro = stage;
    });

    this.planningService.activePlanningSubmenu.subscribe( x => {
      switch (x) {
        case '0':
          this.currentTab = 'planning';
          this.menLPlanningStatus = false;
          this.setPlanningSubMenu();
          break;
        case  '1':
          this.currentTab = 'planning_print-recipes';
          this.menLPlanningStatus = true;
          this.setPlanningSubMenu();
          break;
        case  '2':
          this.currentTab = 'planning_print-menu';
          this.menLPlanningStatus = true;
          this.setPlanningSubMenu();
          break;
        case  '3':
          this.currentTab = 'planning_print-buy';
          this.menLPlanningStatus = true;
          this.setPlanningSubMenu();
          break;
      }
    });

    this.recipeService.getStatusActivatingSort().subscribe(sortStatus => {
      this.isSortActive = sortStatus;
    });

    this.changeFiltersService.getAllowResetRecipes().subscribe(x => {
      this.allowResetMenu = x;
    });

    this.changeFiltersService.getStateReadyMenu().subscribe(x => {
      this.setActiveMenuStatuses(x);
    });

    this.changeFiltersService.getListReadyMenu().subscribe(result => {
      this.readyMenusArr = result;
    });
  }

  ngAfterViewInit() {
    this.introService.getIntroStage().subscribe(stage => {
      this.stageIntro = stage;
      setTimeout(() => {
        if (this.currentTab === 'recipes' && this.isLogged) {
          if (stage === 1) {
            if (this.burgerToggleStatus) this.toggleBurger();
            this.restService.disableBlockStateByLoading();
            this.introSetup(this.introStage1);
          } else if (stage === 2) {
            this.introSetup(this.introStage2);
          } else if (stage === 2.2) {
            this.introSetup(this.introStage3);
          } else if (stage === 6) {
            this.introSetup(this.introStage4);
          }
          if (stage === 1000) {
            this.filterMobile.nativeElement.click();
          }
          if (stage === 1001) {
            this.filterMobile.nativeElement.click();
          }
        }
      }, 1000);
    });
  }

  hasSortAndFiltersValue() {
    return this.isSortActive || this.allActiveFiltersAmount > 0;
  }

  setListenerForStudyCookie() {
    const delay = 5000;
    const obsSub = Observable.interval(delay).subscribe(() => {
      if (this.cookieService.getCookie('isStudyPop') === undefined &&
        !this.popupStartIntro && this.showTimeCookieStudyPopup && this.isLogged) {
        if (this.cookieService.getCookie('SessionId') === '-111') {
          obsSub.unsubscribe();
          return;
        }
        this.introService.setPopupStartIntro(true);
      }
    });
  }

  startIntro() {
    this.introService.setCookieStudyLong();
    this.router.navigateByUrl('/main/recipes/list');
    this.introService.setIntroStage(1);
    this.introService.setPopupStartIntro(false);
  }

  fullStopIntro() {
    this.introService.setCookieStudyLong();
    this.introService.setPopupStartIntro(false);
  }

  tempStopIntro() {
    this.showTimeCookieStudyPopup = false;
    this.introService.setPopupStartIntro(false);
  }

  openIntroPopup() {
    if (this.isLogged) {
      this.toggleBurger();
      this.introService.setPopupStartIntro(true);
    }
  }

  /**
   * запуск и опции для обучения на мобильном
   */
  introSetup(addedSteps, doneLabel?) {
    let step = 1;
    setTimeout(() => {
      this.intro.setOptions({
        exitOnOverlayClick: false,
        doneLabel: doneLabel ? doneLabel : 'Далее &rarr;',
        nextLabel: 'Далее &rarr;',
        prevLabel: '&larr; Назад',
        skipLabel: 'Закрыть',
        steps: addedSteps
      })
        .onbeforechange( (targetElement) => {
          step = +targetElement.getAttribute('id').replace('intro', '');
          if (step === 1 && this.filtersToggleStatus ) {
            this.filtersToggle();
          }
          if (step === 2 && !this.filtersToggleStatus ) {
            this.introService.setIntroStage(1000);
          }
          if (step === 4) {
            this.introService.setIntroStage(1001);
          }
        })
        .oncomplete(() => {
          this.setClassToBody(false, 'intro-hidden');
          this.completeIntro = true;
          if (step === 4 ) {
            this.router.navigateByUrl('/main/recipes/11651');
            this.introService.setIntroStage(100);
          }
          if (step === 6 ) {
            this.introService.setIntroStage(2.2);
          }
          if (step === 7 ) {
            this.router.navigateByUrl('/main/settings/personal');
            this.introService.setIntroStage(107);
          }
          if (step === 17) {
            this.introService.setIntroStage(7);
          }
        })
        .onbeforeexit(() => {
          this.setClassToBody(false, 'intro-hidden');
          if (!this.completeIntro) {
            this.introService.removeIntroAddedRecipe();
          }
        })
        .start();
      this.setClassToBody(true, 'intro-hidden');
    }, 1000);
  }

  getAccountService() {
    this.accountService.isAuthenticated().then(result => {
      this.isLogged = (result.isLoggedIn && !result.isAnonymous);
      this.isLandingsHeader = ( (this.currentTab === 'welcome' || this.currentTab === 'settings' ) && !this.isLogged);
    });
  }

  async getLocation(path: string) {
    if (!path) {
      return;
    }
    this.menLPlanningStatus = false;
    if (path.indexOf('/main/recipes/') !== -1) {
      this.currentTab = 'recipes';
      this.showHeaderFilters = true;
      this.menuInstructionListStatus = false;
      this.menuDocumentsListStatus = false;
      this.menuLKListStatus = false;
    }
    if (path.indexOf('/recipes/create') !== -1) {
      this.currentTab = 'create';
    }
    if (path.indexOf('/recipes/planning') !== -1) {
      const hash = path.split('#').pop();
      switch (hash) {
        case  'print-buy':
          this.currentTab = 'planning_print-buy';
          this.planningService.activePlanningSubmenu.next('3');
          this.menLPlanningStatus = true;
          this.setPlanningSubMenu();
          break;
        case  'print-recipes':
          this.currentTab = 'planning_print-recipes';
          this.planningService.activePlanningSubmenu.next('1');
          this.menLPlanningStatus = true;
          this.setPlanningSubMenu();
          break;
        case  'print-menu':
          this.currentTab = 'planning_print-menu';
          this.planningService.activePlanningSubmenu.next('2');
          this.menLPlanningStatus = true;
          this.setPlanningSubMenu();
          break;
        default:
          this.currentTab = 'planning';
          this.planningService.activePlanningSubmenu.next('0');
          this.menLPlanningStatus = false;
          this.setPlanningSubMenu();
          break;
      }
    }
    if (path.indexOf('/instructions') !== -1) {
      this.currentTab = 'instructions';
      this.showHeaderFilters = false;
      this.menuInstructionListStatus = true;
      this.menuDocumentsListStatus = false;
      this.menuLKListStatus = false;
    }
    if (path.indexOf('/main/recipes/application') !== -1) {
      this.currentTab = 'application';
      this.showHeaderFilters = false;
      this.menuInstructionListStatus = false;
      this.menuDocumentsListStatus = false;
      this.menuLKListStatus = false;
    }
    if (path.indexOf('/info/contacts') !== -1) {
      this.currentTab = 'contacts';
      this.showHeaderFilters = false;
      this.menuDocumentsListStatus = false;
      this.menuLKListStatus = false;
    }
    if (path.indexOf('/info/eula') !== -1) {
      this.currentTab = 'eula';
      this.menuDocumentsListStatus = true;
      this.showHeaderFilters = false;
      this.menuLKListStatus = false;
    }
    if (path.indexOf('/info/confidential') !== -1) {
      this.currentTab = 'confidential';
      this.menuDocumentsListStatus = true;
      this.showHeaderFilters = false;
      this.menuLKListStatus = false;
    }
    if (path.indexOf('/info/useroffer') !== -1) {
      this.currentTab = 'useroffer';
      this.menuDocumentsListStatus = true;
      this.menuInstructionListStatus = false;
      this.showHeaderFilters = false;
      this.menuLKListStatus = false;
    }
    if (path.indexOf('/info/blog') !== -1) {
      this.currentTab = 'blog';
      this.menuDocumentsListStatus = false;
      this.menuInstructionListStatus = false;
      this.menuLKListStatus = false;
      this.showHeaderFilters = false;
    }
    if (path.indexOf('/settings/') !== -1) {
      this.menuDocumentsListStatus = false;
      this.menuInstructionListStatus = false;
      this.menuLKListStatus = true;
      this.showHeaderFilters = false;
    }
    if (path.indexOf('/settings/planning') !== -1) {
      this.currentTab = 'settings_planning';
    }
    if (path.indexOf('/settings/messages') !== -1) {
      this.currentTab = 'settings_messages';
    }
    if (path.indexOf('/settings/personal') !== -1) {
      this.currentTab = 'settings_personal';
    }
    if (path.indexOf('/settings/tariff') !== -1) {
      this.currentTab = 'settings_tariff';
    }

    if (path.indexOf('/welcome') !== -1) {
      this.currentTab = 'welcome';
      this.redirectToWelcome = false;
      this.showHeaderFilters = false;
    } else {
      this.redirectToWelcome = true;
    }
    return this.currentTab;
  }

  isCurrentTabSettings() {
    return this.currentTab === 'settings_planning' || this.currentTab === 'settings_messages'
      || this.currentTab === 'settings_personal' || this.currentTab === 'settings_tariff';
  }

  goToLogo() {
    if (this.isLogged) {
      this.router.navigateByUrl('/main/recipes/planning');
      this.currentTab = 'planning';
    } else {
      this.router.navigateByUrl('/main/recipes/list');
      this.currentTab = 'recipes';
    }
  }

  setPlanningSubMenu() {
    this.showHeaderFilters = true;
    this.menuInstructionListStatus = false;
    this.menuDocumentsListStatus = false;
    this.menuLKListStatus = false;
  }

  goToPage(title) {
    // this.currentTab = title;
    if (title === 'outsideLink') {
      window.location.href = this.Config.linkForOrderReadyMenu;
    }
    if (this.currentTab === 'planning') {
      this.planningService.activePlanningSubmenu.next('0');
    }
    if (this.burgerToggleStatus) {
      this.toggleBurger();
    }
  }

  settingRouter() {
    let result: string;
    if (this.newMessage && this.isLogged) {
      result = '/main/settings/messages';
    } else if (!this.newMessage && this.isLogged) {
      result = '/main/settings/planning';
    } else if (!this.isLogged) {
      result = '/main/settings/tariff';
    }
    return result;
  }

  toggleBurger() {
    this.closeAllModal(null);
    this.burgerToggleStatus = !this.burgerToggleStatus;
    (this.burgerToggleStatus) ? this.document.body.classList.add('burger-open') : this.document.body.classList.remove('burger-open');
  }

  toggleDocumentsList(e) {
    e.preventDefault();
    this.menuDocumentsListStatus = !this.menuDocumentsListStatus;
  }

  toggleLKList(e) {
    e.preventDefault();
    this.menuLKListStatus = !this.menuLKListStatus;
  }

  toggleMenuReadyList(e?) {
    if (e) e.preventDefault();
    this.menuReadyMenuOpenStatus = !this.menuReadyMenuOpenStatus;
  }

  toggleInstructionsList(e) {
    e.preventDefault();
    this.menuInstructionListStatus = !this.menuInstructionListStatus;
  }

  togglePlanningMenu(e) {
    e.preventDefault();
    this.menLPlanningStatus = !this.menLPlanningStatus;
  }

  clearFilters() {
    this.recipeService.clearFilters();
    this.recipeService.setFilter('IsExcluded', '0');
  }

  logOut() {
    this.accountService.logOutWithRequest().then( () => {
      if (this.burgerToggleStatus) {
        if (this.currentTab === 'welcome') {
          window.location.pathname = '/welcome';
        } else {
          this.toggleBurger();
          this.router.navigateByUrl('/welcome');
          this.currentTab = 'welcome';
        }
      }
    });
  }

  logInAnonymous() {
    this.toggleBurger();
    this.openLoginDialog();
  }

  callAuthorization() {
    this.toggleBurger();

    this.restorationPopupDisplayed = false;
    this.landingService.toggleSignupDialog(false);
    this.landingService.toggleLoginDialog(false);
    this.landingService.toggleAuthorizationDialog(true);
  }

  openLoginDialog() {
    this.user = new UserRequest();
    this.authorizationPopupDisplayed = false;
    this.restorationPopupDisplayed = false;
    this.landingService.toggleSignupDialog(false);
    this.landingService.toggleLoginDialog(true);
  }

  searchToggle() {
    this.closeAllModal(this.searchToggleStatus);
    this.searchToggleStatus = !this.searchToggleStatus;
  }

  datepickerToggle() {
    this.closeAllModal(this.datepickerToggleStatus);
    this.datepickerToggleStatus = !this.datepickerToggleStatus;
    this.datepicker.changeWeeksBarStatus = this.datepickerToggleStatus;
  }

  searchStatusChange(status) {
    this.searchBoxStatus = status;
  }

  sortingCheck() {
    this.isRunGetRecipe = true;
  }

  booksFiltersAmountCheck(amount) {
    this.booksFiltersAmount = amount;
    this.allFiltersCount(false);
  }

  categoryFiltersAmountCheck(event) {
    this.categoryFilterEvent = event;
    const status = event.node['IsSelected'];
    (status) ? this.categoryFiltersAmount = 1 : this.categoryFiltersAmount = 0;
    this.allFiltersCount(true);
  }

  groupFilterCheck(label) {
    (label.length > 0) ? this.groupFilterCheckAmount = 1 : this.groupFilterCheckAmount = 0;
    this.allFiltersCount(true);
  }

  ingredientFilterAmountCheck(amount) {
    this.ingredientFilterAmount = amount;
    this.allFiltersCount(true);
  }

  allFiltersCount(statusGet) {
    this.isRunGetRecipe = statusGet;
    this.allActiveFiltersAmount =
      this.categoryFiltersAmount + this.groupFilterCheckAmount
      + this.ingredientFilterAmount + this.booksFiltersAmount;

    if (this.stateReadyMenu.length > 0 && this.allActiveFiltersAmount !== 1) {
      this.changeFiltersService.setAllowResetRecipes(false);
      this.changeFiltersService.cancelStateReadyMenu();
    }
  }

  resetAllFilters() {
    if (this.allActiveFiltersAmount > 0) {
      if (this.categoryFilterEvent) { this.categoryFilter.resetSelected(this.categoryFilterEvent); }
      if (this.groupFilterCheckAmount === 1) { this.groupFilter.resetSelected(); }
      if (this.ingredientFilterAmount > 0) { this.ingredientFilter.clearFilter(); }
      if (this.booksFiltersAmount > 0) { this.bookFilter.resetSelected(true); }
    }
    if (this.isSortActive) {
      this.recipeService.deactivateSort();
    }
  }

  filtersToggle() {
    this.closeAllModal(this.filtersToggleStatus);
    this.filtersToggleStatus = !this.filtersToggleStatus;
    if (!this.filtersToggleStatus) {
      if (this.isRunGetRecipe) {
        this.recipeService.get(true);
        this.recipeService.getShort(true);
      }
      this.scrollToTopRecipe();
      this.categoryFilter.mobileListClose();
      this.groupFilter.mobileListClose();
      this.bookFilter.mobileListClose();
    }
  }

  scrollToTopRecipe() {
    this.recipeService.clearScrollRecipes(false).then(y => {
      if (y || !this.isRunGetRecipe) {
        document.getElementById('midScrollContainer').scrollTop = 0;
      }
      this.isRunGetRecipe = true;
    });
  }

  closeAllModal(clicked) {
    if (clicked !== this.filtersToggleStatus && this.filtersToggleStatus) { this.filtersToggleStatus = false; }
    if (clicked !== this.searchToggleStatus && this.searchToggleStatus) { this.searchToggleStatus = false; }
    if (clicked !== this.datepickerToggleStatus && this.datepickerToggleStatus) {
      this.datepickerToggleStatus = false;
      this.datepicker.changeWeeksBarStatus = false;
    }
  }

  closeSearch(e) {
    this.searchToggleStatus = !e;
  }

  setClassToBody(status, newClass) {
    (status) ? this.document.body.classList.add(newClass) : this.document.body.classList.remove(newClass);
  }

  /**
   * change recipes ready menu
   * @param id
   */
  changeRecipesReadyMenuFilter(id: number) {
    this.isRunGetRecipe = false;
    if (this.currentTab !== 'planning' && this.currentTab !== 'recipes') {
      this.router.navigateByUrl('/main/recipes/list');
    }
    this.toggleBurger();
    this.toggleMenuReadyList();
    if (this.readyMenuTimeout) clearTimeout(this.readyMenuTimeout);
    this.readyMenuTimeout = setTimeout(() => {
      this.changeFiltersService.showReadyRecipes(id);
      this.scrollToTopRecipe();
    }, 0);
  }

  /**
   * set Active states
   * @param state
   */
  setActiveMenuStatuses(state: number[]) {
    this.readyMenusArr.forEach((item) => {
      item.active = state.length > 0 ? state.includes(item.id_Section) : false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/header-mobile/header-mobile.component.ts